import { render, staticRenderFns } from "./HeaderTwo.vue?vue&type=template&id=6efcb72c&"
import script from "./HeaderTwo.vue?vue&type=script&lang=js&"
export * from "./HeaderTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports